<template lang="pug">
  div(class="user-info scroll-y")
    div
      div(class="user-info__name font--28")
        span {{user.name}}
      div(class="user-info__work")
        span 平均每日工作量  (目前為假資料)
        div(class="work__detail" )
          div(v-for="(info,index) in trashDetails")
            span {{info.term}}
            div
              span(class="span-amount") {{info.amount}}
              span(class="span-unit") {{info.unit}}
    div(class="user-info__trash-can block--normal")
      div
        time-picker(:img="`${require('@/assets/icon/date.svg')}`" :time="'2018/01/01'")
        button-modal(:img="`${require('@/assets/icon/btn_editor.svg')}`"  :text="'編輯'" :modalType="'userCan'" :user="user")
      div
        div
          span 垃圾桶
          span 垃圾量
          span 廢棄物
          span 回收物
        div(class="average-work block--inner--fill")
          div
            span(:style="{'font-size': '12px' ,'color': '#3C3C3C'}") 總計
            div
              span(class="span-amount--smaller") {{getUserCans(user.id,cansInfo).length}}
              span(class="span-unit--smaller") 個
          div
            span(class="span-amount--smaller") {{getTotalAmount}}
            span(class="span-unit--smaller") L
          div
            span(class="span-amount--smaller") {{getUserTrashAmount}}
            span(class="span-unit--smaller") L
          div
            span(class="span-amount--smaller") {{getUserRecyclingAmount}}
            span(class="span-unit--smaller") L
        trash-can-info(
          v-for="(can,index) in getUserCans(user.id,cansInfo)"
          :key="`can-${index}`"
          :can="can")
</template>

<script>
import TimePicker from '@/components/TimePicker.vue'
import ButtonModal from '@/components/ButtonModal.vue'
import TrashCanInfo from '@/components/userManagement/TrashCanInfo.vue'
import { getUserCans } from '@/utils/dataHandler.js'
import gsap from 'gsap'
import { mapGetters } from 'vuex'

export default {
  props: {
    user: Object
  },
  components: {
    TimePicker,
    ButtonModal,
    TrashCanInfo
  },
  data () {
    return {
      getUserCans,
      tl: null
    }
  },
  mounted () {
    this.tl = gsap.timeline()
    this.tl.from('.user-info__name', {
      durtion: 0.5,
      x: -50,
      opacity: 0
    })
      .from('.user-info__work', {
        durtion: 0.5,
        x: -50,
        opacity: 0
      }, '-=0.2')
      .from('.user-info__trash-can', {
        durtion: 0.5,
        x: -50,
        opacity: 0
      }, '-=0.2')
  },
  activated () {
    this.tl.restart()
  },
  watch: {
    user () {
      this.tl.restart()
    }
  },
  computed: {
    trashDetails () {
      return [
        {
          term: '垃圾桶',
          amount: this.user.amountOfCan,
          unit: '個'
        },
        {
          term: '總垃圾量',
          amount: this.user.trashAmount + this.user.recyclingAmount,
          unit: 'L'
        },
        {
          term: '廢棄物',
          amount: this.user.trashAmount,
          unit: 'L'
        },
        {
          term: '回收物',
          amount: this.user.recyclingAmount,
          unit: 'L'
        }
      ]
    },
    ...mapGetters({
      cansInfo: 'getCansInfo'
    }),

    getUserTrashAmount () {
      return this.getUserCans(this.user.id, this.cansInfo).map(can => can.trash.volume).reduce((acc, curr) => acc + curr, 0)
    },
    getUserRecyclingAmount () {
      return this.getUserCans(this.user.id, this.cansInfo).map(can => can.recycling.volume).reduce((acc, curr) => acc + curr, 0)
    },
    getTotalAmount () {
      return this.getUserTrashAmount + this.getUserRecyclingAmount
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/scss/helper/variables.scss";

.user-info {
  display: flex;
  flex-direction: column;
  text-align: left;
  box-sizing: border-box;
  padding: 35px 40px;
  width: 100%;
  height: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  > div:nth-child(1) {
    padding: 0 10px;
    margin-bottom: 25px;
  }
  &__work {
    > span {
      font-size: 16px;
      color: map-get($colors, light-black);
      font-weight: 100;
      padding-left: 8px;
      line-height: 60px;
    }
  }
  &__trash-can {
    flex: 1;
    > div:nth-child(1) {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: center;
    }
    > div:nth-child(2) {
      display: flex;
      flex-direction: column;
      > div:nth-child(1) {
        display: grid;
        padding: 0 20px 0 20px;
        justify-items: left;
        grid-template-rows: 1fr;
        grid-template-columns: 1fr 1.5fr 1.5fr 0.5fr 1.5fr;
        > span {
          color: map-get($colors, dark-gray);
          font-size: 14px;
        }
      }
    }
  }
  .work__detail {
    padding: 0 30px;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    box-sizing: border-box;
    > div {
      display: flex;
      flex-direction: column;
      > span {
        font-size: 14px;
        color: map-get($colors, dark-gray);
      }
    }
    > div:nth-child(n)::after {
      padding: 5px 20px;
      border-right: 1px solid map-get($colors, gray);
    }
  }
  .average-work {
    display: grid;
    justify-items: left;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 1.5fr 1.5fr 0.5fr 1.5fr;
    > div:nth-child(1) {
      display: flex;
      > div {
        transform: translateX(20%);
      }
    }
  }
  .span-amount {
    font-size: 35px;
    color: map-get($colors, light-black);
    margin-right: 10px;
    &--smaller {
      font-size: 23px;
      margin-right: 7px;
    }
  }
  .span-unit {
    font-size: 20px;
    color: map-get($colors, light-black);
    &--smaller {
      font-size: 13px;
    }
  }
}
</style>
